module.exports = __webpack_public_path__ + "static/ocr-6d717b371f7d09d79803b192d6c38ae3.webm";